import React, { useState } from "react";
import { WithApiFileLocationProvider } from "./WithApiFileLocationProvider";
import { fetchNonTagetikDocumentsList } from "../../api/document/Location";
import { FileLocation } from "./FileLocationProvider";
import { DocumentLocationExplorer } from "./DocumentLocationExplorer";
import { FlatPathTreeItem } from "../generic/FlatPathTreeExplorer";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import FooterPanel from "../layout/FooterPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { DocumentData, EditDocument } from "./EditDocument";
import { defaultFormatting } from "../../utils/constants/formats";
import { fetchDocumentMetadata } from "../../api/document/DocumentsPart";

export const LinkNonTagetikDocumentPanel = ({
  onLink,
  fatherPartId,
  isFatherMultilinked,
}: {
  onLink: (documentData: DocumentData, driveItemId: string) => Promise<void>;
  fatherPartId: string;
  isFatherMultilinked: boolean;
}) => {
  const [state, setState] = useState<{
    zipFileItem: FlatPathTreeItem | undefined;
    loadedZip: boolean;
    page: "FILE" | "EDIT";
  }>({
    zipFileItem: undefined,
    loadedZip: false,
    page: "FILE",
  });

  function onSelectZipFileItem(item: FlatPathTreeItem | undefined) {
    if (!item || !item.document || item.document.folder) setState({ ...state, zipFileItem: undefined });
    else setState({ ...state, zipFileItem: item });
  }

  return (
    <>
      <WithApiFileLocationProvider
        selectDepth="ITEM"
        cleanState={!state.loadedZip}
        getItems={async (path) => {
          const documentFolder = await fetchNonTagetikDocumentsList(path);

          setState((s) => ({ ...s, loadedZip: true }));

          return documentFolder.map<FileLocation>((df) => {
            return {
              key: df.driveItemId,
              text: df.name,
              path: df.path,
              iconName: df.folder ? "fabricFolder" : "wordDocument",
              document: df,
            };
          });
        }}
      >
        {state.page === "FILE" && <DocumentLocationExplorer onSelectItem={onSelectZipFileItem} />}
      </WithApiFileLocationProvider>
      {state.page === "EDIT" && (
        <EditDocument
          fatherPartId={fatherPartId}
          editDocumentOperationType={"IMPORTNONTAGETIK"}
          isEdit={false}
          onLastBackButton={() => setState((s) => ({ ...s, page: "FILE" }))}
          onSave={(dp) => onLink(dp, state.zipFileItem.key)}
          getDocumentPartDetails={async () => {
            const fatherMetadata = await fetchDocumentMetadata(fatherPartId);
            return {
              documentData: {
                description: undefined,
                name: state.zipFileItem.text,
                root: false,
                multilinked: isFatherMultilinked,
                path: state.zipFileItem.path,
                documentId: undefined,
                advanced: defaultFormatting,
                language: fatherMetadata.language,
                parameters: [],
              },
              fatherDocumentParameters: fatherMetadata.parametersMetadata,
            };
          }}
        />
      )}
      {state.page === "FILE" && (
        <FooterPanel>
          <PrimaryButton
            id="next_button"
            data-testid={"next"}
            disabled={!state.zipFileItem}
            allowDisabledFocus
            text={formatMessage("cof.base.next")}
            style={{ float: "right" }}
            onClick={() => setState((s) => ({ ...s, page: "EDIT" }))}
          />
        </FooterPanel>
      )}
    </>
  );
};
